<template>
  <div class="login">
    <div class="container pb-5">
      <div class="row justify-content-center">
        <div class="col-lg-5 col-md-7 py-3 py-lg-4 my-5 my-lg-5 card shadow border-0">
          <!-- Header -->
          <div class="header">
            <div class="header-body text-center mb-3">
              <img alt="My Cloud" src="@/assets/img/brand/logo-round-sm.png" class="logo">
              <h1 class="mt-2 mb-0">Password Reset</h1>
            </div>
          </div>
          <!-- Page content -->
          <div class="card-body px-lg-5 py-lg-2">
            <form role="form" @submit.prevent='submitLogin'>
              <div class="form-group mb-3">
                <div class="input-group input-group-alternative">
                  <div class="input-group-prepend">
                    <span class="input-group-text"><i class="ni ni-email-83"></i></span>
                  </div>
                  <input class="form-control" v-model="email" placeholder="Email" type="email">
                </div>
              </div>
              <div class="text-center">
                <b-button variant="success" type="submit" class="mt-4 mb-2" v-if="!loading"> Submit </b-button>
                <button class="btn login_buttons px-4" type="button" v-if="loading">Loading</button>
                <!-- <button type="button" class="btn btn-primary my-4">Sign in</button> -->
              </div>
            </form>
          </div>
          <div class="row">
            <div class="col-12 text-center">
              <router-link :to="{ name: 'adminLogin' }" class="nav-link">
                <small>LOGIN</small>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    email: '',
    loading: false,
  }),
  computed: {
    ...mapGetters('authentication', ['userGetter',]),
    getData() {
      console.log(this.userGetter, "=====userGetter")
      if (this.userGetter) {
        if (localStorage.roleId == 1) {
          this.$router.replace({ name: "dashboard" });
        }
        if (localStorage.roleId == 2) {
          this.$router.replace({ name: "Home" });
        }
      }
    }
  },
  methods: {
    ...mapActions('authentication', ['FORGOT_PASSWORD']),
    submitLogin() {
      this.loading = true;
      const re = /[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}/igm;

      if (!this.email) {
        this.loading = false;
        this.ERROR_TOAST_MSG('Enter all fields');
        return;
      }

      if (!re.test(this.email)) {
        this.loading = false;
        this.ERROR_TOAST_MSG('Enter a valid email.');
        return;
      }

      const body = { email: this.email };

      this.FORGOT_PASSWORD(body)
        .then((response) => {
          console.log(response, "API Response ✅"); // <-- This will now fire properly

          this.loading = false;

          // Check if response.status is `true`, not `200`
          if (response.status === true) {
            this.email = ''; // Clear email field only if success
          }

          this.SUCCESS_TOAST_MSG(response.message || "Password reset link sent successfully!");

          setTimeout(() => {
            this.$router.replace({ name: "adminLogin" });
          }, 2000);
        })
        .catch((error) => {
          console.error(error, "API Error ❌");
          this.loading = false;
          this.ERROR_TOAST_MSG("Something went wrong. Please try again.");
        });
    },
  },
  created() {
    if (localStorage.roleId == 1) {
      this.$router.replace({ name: "dashboard" });
    }
    if (localStorage.roleId == 2) {
      this.$router.replace({ name: "Home" });
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Authenticaion/forgotPassword.vue